import { useRef, useState } from 'react';

const DRAG_LEAVE_DELAY_MS = 150;

export const useFileDragActive = () => {
  const [isDragActive, setIsDragActive] = useState(false);
  const timeoutReference = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const onDragOver = () => {
    setIsDragActive(true);
    clearTimeout(timeoutReference.current);
    timeoutReference.current = setTimeout(() => setIsDragActive(false), DRAG_LEAVE_DELAY_MS);
  };

  const onDrop = () => {
    clearTimeout(timeoutReference.current);
    setIsDragActive(false);
  };

  return { isDragActive, onDragOver, onDrop };
};
